module.exports = __webpack_public_path__ + "img/bg.1641520899224.png";